import {
  Block,
  Button,
  List,
  ListInput,
  ListItem,
  Page,
  Popup,
} from "framework7-react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import PopupNavbar from "../../components/popup-navbar";
import { usePopupBackClose } from "../../hooks/use-back-close";
import { useEnterKeys } from "../../hooks/use-enter-keys";
import { useToast } from "../../hooks/use-toast";
import { joinGroup } from "../../redux/reducer/app-slice";

const JoinGroupPopup = ({
  opened,
  onClose = () => {},
  onJoined = () => {},
}) => {
  const [code, setCode] = useState("");
  const backClose = usePopupBackClose(opened);
  useEnterKeys(backClose.id, { "join-code-input": { hint: "go" } });
  const { showError } = useToast();
  const dispatch = useDispatch();

  const handleSubmit = (event) => {
    event.preventDefault();
    dispatch(
      joinGroup(
        code,
        (group) => {
          setCode("");
          onJoined(group);
        },
        showError,
      ),
    );
  };

  return (
    <Popup
      {...backClose}
      className="join-group-popup"
      opened={opened}
      // autofocus does nothing on an input inside a hidden popup.
      onPopupOpened={(popup) =>
        popup.el.querySelector("input[name=join-code-input]")?.focus()
      }
      onPopupClosed={() => {
        setCode("");
        onClose();
      }}
    >
      <Page>
        <PopupNavbar title="Gruppe beitreten" />
        <Block>
          <List strong form formStore={false} onSubmit={handleSubmit}>
            <ListInput
              name="join-code-input"
              outline
              type="text"
              autocomplete="off"
              autocorrect="off"
              autocapitalize="characters"
              spellcheck={false}
              maxlength={6}
              minlength={6}
              required
              placeholder="... ..."
              value={code}
              onChange={(event) => setCode(event.target.value)}
              className="uppercase"
            />
            <ListItem>Gib deinen Einladungs-Code ein.</ListItem>
            <ListItem>
              <Button type="submit" fill disabled={code.length !== 6}>
                Beitreten
              </Button>
            </ListItem>
          </List>
        </Block>
      </Page>
    </Popup>
  );
};

export default JoinGroupPopup;
